export const LOGIN_URL = '/auth/login';
export const REQUEST_PASSWORD_RESET_URL = '/auth/requestToken';
export const VALIDATE_TOKEN_URL = '/auth/validateToken';
export const RESET_PASSWORD_URL = '/auth/resetPassword';

export const MEMBER_URL = '/members'
export const TREATMENT_FROM_ME_URL = '/auth/login';
export const TREATMENT_NEED_MY_REVIEW_URL = '/auth/login';
export const UPLOAD_IMAGE_URL = '/upload';
export const UPLOAD_IMAGE_URLNew = '/utils/upload-image';
export const NEWS_POSTS_URL = '/marketing/news-post/';
export const NEWS_GET_URL = '/news';
export const NEWS_ORDER_URL = '/news/sort/order';
export const NEWS_CATEGORY_URL = '/news/category';
export const POST_EXPOSURE_FILTER_URL = '/marketing/news-post/exposure-filter';
export const AUTHORIZATION_ROLE_URL = '/authorizations/roles';
export const AUTHORIZATION_ROLE_CREATE_URL = '/authorizations/role';
export const AUTHORIZATION_RIGHTS_URL = '/authorizations/rights';
export const STAFF_LIST_URL = '/staffs/list';
export const STAFF_CREATE_URL = '/staffs/create';
export const STAFF_DELETE_URL = '/staffs/delete';
export const STAFF_DETAIL_URL = '/staffs';
export const AUTHORIZATION_RIGHT_URL = '/authorizations/right';
export const MAGAZINES_URL = '/magazines'
export const MAGAZINE_TYPE_URL = '/magazines/type'
export const UPLOAD_PUBLIC_URL = '/files/upload'
export const UPLOAD_PRIVATE_URL = '/files/upload/excl'
export const GET_PRIVATE_URL = '/files'
export const DASHBOARD_PAYMENT_URL = "/payments/report"
export const PAYMENT_URL = "/payments"
export const MEMBER_REPORT_URL = "/members/report"
export const MEMBER_SUBSCRIPTION_URL ="/members/subscription"
export const TAGS_URL = "/tags"
export const PROMOTION_CODE_URL ="/promoCodes"
export const TEACHER_URL = '/teachers'
export const COURSE_CATEGORY_URL = '/course-categories'
export const COURSE_URL ="/courses"
export const UPLOAD_VIDEO_URL = '/files/teacher/video'
export const TEACHER_REPORT_URL = "/teachers/report"
export const COURSE_REPORT_URL = "/courses/report"
export const MEMBER_SETTING_URL = "/members/setting"
export const UPLOAD_VIDEO_GET_URL = '/files/upload-status'
export const UPLOAD_VIDEO_COURSE_URL = '/files/course/video'
export const UPLOAD_VIDEO_COURSE_PUBLIC_URL = '/files/course/public-video'
export const PRODUCT_URL = '/products';
export const ADSSETTING_URL = '/ads'
export const PRODUCT_CATEGORY_URL = "/product-categories"
export const DASHBOARD_ORDER_URL = "/orders/report"
export const ORDERS_URL = "/orders"
export const ORDER_SHIPED_URL = "/orders/shipping"
export const EXPORT_ORDER_URL="/orders/export"
export const PRESIGNED_UPLOAD_URL = '/files/presigned-upload-url';
export const FASHION_URL = '/fashions';
export const GALLERY_URL = '/gallery';
export const TECHNICALS_URL= '/technicals';
export const TECHNICALS_CATEGORY_URL= '/technicals/category';
export const BANNER_URL = '/banners';
export const COUPON_URL= '/coupons-batches';
export const COUPON_USED_URL= '/coupons-batches/used';
export const EVENTS_URL = '/events';
export const EVENT_SUBMISSIONS_URL = '/events/submitions';
export const EVENT_ADMISSION_URL = '/events/admission';
export const EVENT_CODE_BATCHES_URL = '/event-code-batches';
export const EVENT_CODE_BATCHES_USED_URL = '/event-code-batches/used';
export const EVENT_SUBMISSIONS_SCAN_URL = '/events/submitions-scan';
export const EVENT_SUBMISSIONS_CHECKIN_URL = '/events/submitions-checkin';
export const PRODUCTS_KNOWLEDGE_URL = '/products-knowledge';
export const PRODUCTS_KNOWLEDGE_CATEGORY_URL = '/products-knowledge/category';

